import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService, ToastMessage } from '../../../common/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css']
})
export class ToastComponent implements OnInit, OnDestroy {
  message: string | null = null;
  private subscription!: Subscription;
  private hideTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.subscription = this.toastService.toast$.subscribe((toast: ToastMessage) => {
      // If a toast is already showing, clear it and reset
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
        this.message = null;
      }

      // Small delay allows Angular to re-trigger the animation when replacing
      setTimeout(() => {
        this.message = toast.message;
        // Match the 2s animation duration
        this.hideTimer = setTimeout(() => {
          this.message = null;
          this.hideTimer = null;
        }, 2000);
      }, 50);
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.hideTimer) clearTimeout(this.hideTimer);
  }
}